const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    invitationId: z.uuid().optional(),
    openInvitationId: z.uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Overview",
      description: "Page title for the group overview page"
    })
  }
});